import { isEmpty, cloneDeep } from 'lodash';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-use';
import { metalStreamMenu } from '../constants/menus/metalStreamMenu';
import { ACCOUNT_TYPE, APPLICATION_TYPE } from '../constants/sessionStorage';
import { applicationOnboardingSetupSuccess } from '../store/actions/application/applicationActions';
import { selectApplicationOnboarding } from '../store/selectors/applicationSelectors';
import { getMenuByApplication } from '../util/helpers/getMenuByApplicationHelper';
import { retrieveFromSessionStorage } from '../util/helpers/sessionStorageHelper';
import {
  findItemTreeByPathname,
  modifyItemTreeByPathname,
} from '../util/helpers/treeSearchHelper';
import useAipFlow from './useAipFlow';

const getMenuCurrentState = (menu, pathname) => {
  const currentMenu = cloneDeep(menu);
  modifyItemTreeByPathname(currentMenu, pathname);

  return currentMenu;
};

export const useMenu = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const applicationOnboarding = useSelector(selectApplicationOnboarding);
  const ApplicationType = retrieveFromSessionStorage(APPLICATION_TYPE);
  const AccountType = retrieveFromSessionStorage(ACCOUNT_TYPE);
  const { isAipFlow } = useAipFlow();

  const getCurrentMenu = () => {
    if (isAipFlow) {
      return metalStreamMenu;
    }

    if (ApplicationType && AccountType) {
      return getMenuByApplication(ApplicationType, AccountType);
    }

    return getMenuByApplication(ApplicationType);
  };

  const currentMenu = getCurrentMenu();

  useEffect(() => {
    if (location.pathname && currentMenu) {
      const activeItem = findItemTreeByPathname(currentMenu, location.pathname);

      if (!isEmpty(activeItem)) {
        const activeMenu = getMenuCurrentState(currentMenu, location.pathname);

        if (!isEmpty(activeMenu)) {
          dispatch(
            applicationOnboardingSetupSuccess({
              ApplicationOnboardingMenu: activeMenu,
              ApplicationOnboardingStep: activeItem,
            }),
          );
        }
      }
    }
  }, [location.pathname, currentMenu, dispatch]);

  return {
    activeMenu: applicationOnboarding?.ApplicationOnboardingMenu || [],
    activeItem: applicationOnboarding?.ApplicationOnboardingStep || {},
  };
};
